import angular, { ILogService, ITimeoutService } from 'angular'
import { chain } from 'lodash'
import { tap } from 'rxjs'
import { AppConfigService } from 'src/_candidato/comun/services/app-config.service'
import { Formulario } from 'src/_candidato/data/formulario'
import { NotificacionService } from '../../../../_panel/module/uni-base/services/NotifService'
import { IEdicionForm, IFormBloque, IFormCompleto } from '../../../../model/candidato-api'
import { AccesoDatos } from '../../../comun/services/acceso-datos'
import { BloqueForm } from '../../../data/bloque-form'
import { BaseFeaturesComponent } from '../_base/base-features.component'

class TarjetaFormularComponentCtrl extends BaseFeaturesComponent {
  formular!: Formulario
  edit!: boolean
  onNuevoForm!: (arg0: { form: IEdicionForm }) => void

  formdata: IFormCompleto
  bloques: BloqueForm[]
  verSecciones: boolean

  dirty = false

  defaultactive = ''

  editaDocAttach = false

  constructor(
    private $element: JQLite,
    private $timeout: ITimeoutService,
    private $log: ILogService,
    private NotifService: NotificacionService,
    private AccesoDatos: AccesoDatos,
    appConfigService: AppConfigService
  ) {
    super(appConfigService)

    this.autoUnsub(
      //
      this._flags
        .pipe(
          tap((flags) => {
            this.editaDocAttach = flags.editaAccesoPublico
          })
        )
        .subscribe()
    )
  }

  $onInit(): void {
    this.$log.info('[TarjetaFormularComponentCtrl] onInit')

    if (this.edit) this.verSeccionesForm()

    this.defaultactive = this.formular.esNuevo ? '' : 'active'
  }

  $postLink() {
    this.$timeout(() => this._initDrop(), 200)
  }

  private _initDrop() {
    var elems = this.$element.find('.dropdown-trigger')
    M.Dropdown.init(elems, { hover: false, constrainWidth: false, alignment: 'right' })
  }

  verSeccionesForm() {
    this.formular.esNuevo = false

    // leer el formulario si no lo está ya
    if (!this.formdata) {
      this.refreshForm().then(() => {
        this.verSecciones = !this.verSecciones
      })
    } else this.verSecciones = !this.verSecciones
  }

  refreshForm() {
    return this.AccesoDatos.EdicionFormular_CLIENT.leerFormulario(this.formular.data.idform).then((response) => {
      this.formdata = response
      this.bloques = chain(response.bloques)
        .map((b) => new BloqueForm(b))
        .value()
    })
  }

  guardarFormular() {
    this.formular.esNuevo = false

    this.AccesoDatos.EdicionFormular_CLIENT.actualizaForm(this.formular).then((response) => {
      this.formular.actualiza(response)

      this.dirty = false
    })
  }

  nuevoBloque() {
    this.bloques.push(new BloqueForm({ data: { formular_id: this.formular.data.idform } } as IFormBloque))
  }

  duplicarFormulario() {
    this.AccesoDatos.EdicionFormular_CLIENT.duplicaFormulario(this.formular.data.idform).then((response) => {
      this.NotifService.good('El nuevo formulario está al final')

      this.onNuevoForm({ form: response })
    })
  }
}

angular.module('candidato').component('tarjetaFormular', {
  bindings: {
    formular: '<',
    edit: '<',
    onAdd: '&',
    onNuevoForm: '&',
  },
  controller: TarjetaFormularComponentCtrl,
  template: require('./tarjeta-formular.component.html'),
  //templateUrl: "../../../../app/ui/vs/prog/dev/templates/tarjeta-formular/tarjeta-formular.component.html"
})
